import React from 'react';
import { Icon } from './Icon.js';
export const IconPriorityHigh = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8.00001 11L12 7L16 11", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M1.00002 11L11 1.00005L12 1.00005L13 1.00005L23 11L23 12L23 13L13 23.0001L12 23L11 23.0001L1.00001 13L0.999999 12L1.00002 11Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconPriorityHigh.js.map